import { Checkbox, Grid, TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";

import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";

import { capitalizeFirstLetter, formatLength, images } from "../constants";
import { getCreatedByDisplay } from "../utils/createdByUtils";

const QuickTalesTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  setSelectedAudioFile,
  setSelectedImage,
  showPosition,
  removeRow,
  provided,
  position,
  columnWidths,
  hideRemoveLink,
  onTitleClick,
}) => {
  const rows = Array.from({ length: 20 }, (_, index) => index + 1);

  const handleRemoveRow = () => {
    removeRow([row.id]);
  };

  const isTitleClickable = typeof onTitleClick === "function";

  return (
    <TableRow
      ref={provided.innerRef}
      {...provided.draggableProps}
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
            {showPosition && (
        <TableCell
          {...provided.dragHandleProps}
          align="left"
          style={{
            ...tableStatusCellStyles,
            width: columnWidths?.position || 50,
            minWidth: columnWidths?.position || 50,
            maxWidth: columnWidths?.position || 50,
          }}
        >
          <Grid container>
            {row?.position
              ? row?.position
              : position
              ? position + 1
              : position == 0
              ? 1
              : ""}
            <DensityMediumIcon
              onClick={() => {}}
              fontSize={"small"}
              style={{
                width: 24,
                height: 24,
                marginLeft: "auto",
                color: "#808080",
              }}
            />
          </Grid>
        </TableCell>
      )}
      <TableCell
        // component="th"
        id={labelId}
        //scope="row"
        padding="none"
        // onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.title || 200,
          minWidth: columnWidths?.title || 200,
          maxWidth: columnWidths?.title || 200,
        }}
      >
        {isTitleClickable ? (
          <span
            onClick={() => onTitleClick(row)}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            {row?.title}
          </span>
        ) : (
          row?.title
        )}
        {showPosition && !hideRemoveLink && (
          <a
            onClick={handleRemoveRow}
            style={{ color: "#BA344C", cursor: "pointer", display: "block" }}
          >
            Remove
          </a>
        )}
      </TableCell>
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 75,
          minWidth: columnWidths?.photo || 75,
          maxWidth: columnWidths?.photo || 75,
        }}
        onClick={() => {
          setSelectedImage(
            row?.imageUrls?.[0] ?? row?.photoUrl ?? images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        {
          <img
            src={row?.imageUrls?.[0] ?? row?.photoUrl ?? images.QuicktaleLogo}
            // src={row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo}
            alt="empty image"
            style={{ width: 45, height: 40 }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = ""; // Set the source to an empty string or a placeholder image URL
            }}
          />
        }
        {/* <img
          src={row?.photoUrl}
          alt="empty image"
          style={{ width: 45, height: 40 }}
        /> */}
      </TableCell>
      <TableCell
        align="center"
        onClick={() => {
          setSelectedAudioFile(row?.audioUrl);
          handleAudioModalOpen();
        }}
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.audio || 75,
          minWidth: columnWidths?.audio || 75,
          maxWidth: columnWidths?.audio || 75,
        }}
      >
        <PlayCircleFilledWhiteOutlinedIcon
          fontSize="large"
          style={{ color: "#00A7CD" }}
        />
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 200,
          minWidth: columnWidths?.id || 200,
          maxWidth: columnWidths?.id || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          }}
          title={row?.id}
      >
        {row?.id}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdBy || 200,
          minWidth: columnWidths?.createdBy || 200,
          maxWidth: columnWidths?.createdBy || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {getCreatedByDisplay(row?.createdByData, row?.createdBy)}
      </TableCell>

      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.toldBy || 200,
          minWidth: columnWidths?.toldBy || 200,
          maxWidth: columnWidths?.toldBy || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.narratorData
          ? (() => {
              const first = row?.narratorData?.firstName || "";
              const last = row?.narratorData?.lastName || "";
              const userName = row?.narratorData?.userName || "";
              const displayName = `${first} ${last}`.trim();
              return userName ? `@${userName}/${displayName}` : displayName;
            })()
          : row?.narrator}
      </TableCell>

      {/* <TableCell align="left" style={tableCellStyles}>
        {row?.createdAt &&
          moment.unix(row?.createdAt.seconds).format("MM-DD-YYYY")}
      </TableCell> */}
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.listenerType || 200,
          minWidth: columnWidths?.listenerType || 200,
          maxWidth: columnWidths?.listenerType || 200,
        }}
      >
        {capitalizeFirstLetter(row?.status)}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.status || 120,
          minWidth: columnWidths?.status || 120,
          maxWidth: columnWidths?.status || 200,
        }}
      >
        {capitalizeFirstLetter(row?.approvalStatus?.status)}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.updatedAt || 180,
          minWidth: columnWidths?.updatedAt || 180,
          maxWidth: columnWidths?.updatedAt || 220,
        }}
      >
        {row?.approvalStatus?.updatedAt &&
          moment
            .unix(row?.approvalStatus?.updatedAt.seconds)
            .format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.audioLength || 100,
          minWidth: columnWidths?.audioLength || 100,
          maxWidth: columnWidths?.audioLength || 200,
        }}
      >
        {formatLength(row?.audioLength)}
      </TableCell>
    </TableRow>
  );
};

export default QuickTalesTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  paddingLeft: 5,
  color: "#00A7CD",
  cursor: "default",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};
